import React, {
  createContext, useState, useEffect, useRef,
} from 'react';
import { createRoot } from 'react-dom/client';
import { useSnackbar } from 'notistack';
import { TRANCRIPTION_WSS_URL } from './global';

export const TranscriptionWebSocketContext = createContext({
  message: '',
  setContextMessage(message) {
    this.message = message;
  },
});

export function TranscriptionsWebSocketProvider({ children }) {
  const [ws, setWs] = useState(null);
  const [messageState, setMessage] = useState(''); // Proper state for message
  const currentSnackStatus = useRef([]);
  const reconnectRef = useRef(null);
  const root = useRef(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (root.current == null && document.getElementById('status-container')) {
      root.current = createRoot(document.getElementById('status-container'));
    }
  }, []);
  function returnStatusString(status) {
    if (status == 'IN_PROGRESS') {
      return { text: 'Υπό επεξεργασία', code: 1 };
    } if (status == 'NOT_TRANSCRIBED') {
      return { text: 'Δεν έχει γίνει μεταγραφή', code: null };
    } if (status == 'TRANSCRIBED') {
      return { text: 'Ολοκληρώθηκε', code: 0 };
    } if (status == 'FAILED') {
      return { text: 'Απέτυχε', code: 2 };
    }
    status;
  }

  const connectWebSocket = () => {
    const socket = new WebSocket(TRANCRIPTION_WSS_URL);

    socket.onmessage = (event) => {
      const message = JSON.parse(event.data);
      let temp = {}
      setMessage(message);
      temp = {
        status: returnStatusString(message.status),
        id: message.asr_result_id,
        name: message.interview_id,
      };

      let snackSettings = {}
      if (temp.status.code == 1) {
        snackSettings = { autoHideDuration: null, variant: 'info' }
        currentSnackStatus.current = [...currentSnackStatus.current, { snackId: enqueueSnackbar(`${temp.name}: ${temp.status.text}`, snackSettings), asrId: temp.id }];
      } else {
        if (temp.status.code == 2) {
          snackSettings = { autoHideDuration: 3000, variant: 'error' }
        } else {
          snackSettings = { autoHideDuration: 3000, variant: 'success' }
        }
        currentSnackStatus.current.map(each => {
          if (each.asrId == temp.id) {
            closeSnackbar(each.snackId)
            let tempSnackStatus = [...currentSnackStatus.current]
            tempSnackStatus.splice(tempSnackStatus.indexOf(each), 1)
            currentSnackStatus.current = tempSnackStatus
          }
        })
        enqueueSnackbar(`${temp.name}: ${temp.status.text}`, snackSettings)
      }
    };

    socket.onclose = () => {
      console.log('WebSocket Disconnected. Reconnecting...');
      reconnectRef.current = setTimeout(connectWebSocket, 3000); // Auto-reconnect after 3 sec
    };

    socket.onerror = (error) => {
      console.error('WebSocket Error:', error);
    };

    setWs(socket);
  };

  useEffect(() => {
    connectWebSocket();
    return () => {
      if (ws) {
        ws.close();
      }
      if (reconnectRef.current) {
        clearTimeout(reconnectRef.current);
      }
    };
  }, []);

  return (
    <TranscriptionWebSocketContext.Provider value={{ ws, messageState }}>
      <div className="flex flex-col w-full h-full">
        {children}
        <div className="mt-auto w-full" id="status-container" />
      </div>
    </TranscriptionWebSocketContext.Provider>
  );
}
